import { render, staticRenderFns } from "./ReactMountPcpLaboratorial.vue?vue&type=template&id=e9a8efc8"
import script from "./ReactMountPcpLaboratorial.vue?vue&type=script&lang=ts"
export * from "./ReactMountPcpLaboratorial.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\TafStore.PharmUP.Client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e9a8efc8')) {
      api.createRecord('e9a8efc8', component.options)
    } else {
      api.reload('e9a8efc8', component.options)
    }
    module.hot.accept("./ReactMountPcpLaboratorial.vue?vue&type=template&id=e9a8efc8", function () {
      api.rerender('e9a8efc8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/parent/ReactMountPcpLaboratorial.vue"
export default component.exports